<ea-global-header class="bl-print-hide" id="dx-admin-header"
    [logoSrc]="lenderConfig?.darkModeLogo || lenderConfig?.lenderLogoUrl || ''" [logoHref]="logoHref"
    [hideSideNavCtrl]="true"
    [darkMode]="true" class="bl-full-width">
    <div class="bl-display--flex bl-align-items--center bl-width--100 bl-height--100">
        <div class="bl-flex--auto bl-margin-left--16 bl-margin-bottom--4">
            @if(!!environment) {
            <span class="bl-tag bl-tag-condensed bl-text-transform--uppercase bl-font-weight--800"
                [class.info-theme]="environment === 'dev'" [class.plum-theme]="environment === 'qa'"
                [class.success-theme]="environment === 'uat'">
                {{ environment }}
            </span>
            }
        </div>

        <p class="bl-text-style--default-text-2 bl-margin-x--16 bl-margin-bottom--4">
            <span class="bl-font-color--white bl-margin-right--4">{{ lenderConfig?.lenderName }}</span>
            <span class="bl-font-color--darker-snow">({{ lenderConfig?.consumerLoanCode }})</span>
        </p>

        <admin-header-menu id="admin-header-launchpad-menu" menuName="Admin Launchpad"
            toggleClass="bl-font-color--white bl-font-size--22 cu-launchpad bl-font-color--smoke bl-padding-x--16"
            class="bl-height--100 bl-text-align--left">

            @if(userName) {
            <li id="user-name" class="launchpad-user-name bl-display--flex bl-text-transform--lowercase">
                <i class="cu-user-circle bl-align-self--center bl-margin-right--8"></i>
                {{ userName }}
            </li>
            }

            <li class="launchpad-heading-item bl-display--flex bl-text-style--default-text-2">
                <i class="cu-link bl-align-self--center bl-margin-right--8"></i>
                <span class="">Quick Links </span>
            </li>
            <li>
                <a [routerLink]="['/app/oao/membership']" target="_blank" class="bl-padding--16">Start a membership
                    application</a>
            </li>
            <li>
                <a [routerLink]="['/app/ola/ola-consumer-loan-type']" target="_blank" class="bl-padding--16">Start a
                    loan application</a>
            </li>
            <li>
                <a [routerLink]="['/user/login']" target="_blank" class="bl-padding--16">Go to user login</a>
            </li>
            <li>
                <a [routerLink]="['/user/registration']" target="_blank" class="bl-padding--16">Go to user
                    registration</a>
            </li>
            <ng-content></ng-content>
        </admin-header-menu>
    </div>
</ea-global-header>
